import { render, staticRenderFns } from "./category-filed-type.vue?vue&type=template&id=4d3a28f3&scoped=true&"
import script from "./category-filed-type.vue?vue&type=script&lang=js&"
export * from "./category-filed-type.vue?vue&type=script&lang=js&"
import style0 from "./category-filed-type.vue?vue&type=style&index=0&id=4d3a28f3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3a28f3",
  null
  
)

export default component.exports